import { render } from "./McrItemFormDialog.vue?vue&type=template&id=ec8e8458&scoped=true"
import script from "./McrItemFormDialog.vue?vue&type=script&lang=js"
export * from "./McrItemFormDialog.vue?vue&type=script&lang=js"

import "./McrItemFormDialog.vue?vue&type=style&index=0&id=ec8e8458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8e8458"]])

export default __exports__